// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"e0cd3d57","79":"b870d68d","343":"a6e73ed3","429":"22f94eca","482":"696532fb","714":"9968bd36","871":"ca7caafd"}[chunkId] + ".chunk.js";
};